var React = require('react');
import { Box, Container, Grid } from '@mui/material';
import DeleteIcon from "@material-ui/icons/Delete";
import SearchIcon from "@material-ui/icons/Search";
import Button from "@mui/material/Button";
import SaveIcon from "@material-ui/icons/Save";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import { MuiThemeProvider } from '@material-ui/core/styles';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import CloseIcon from '@mui/icons-material/Close';
import { muiThemeDesign } from '../../mui-theme-design';
import { makeStyles } from "@mui/styles";
import { Importer, ImporterField } from '../../csv_import/Importer';
import { useDrag } from '@use-gesture/react'



const pageStyles = makeStyles({

    root: {
        display: "flex",
        //       flexFlow: "column wrap",
        gap: "5px",
        //      height: "400px", 
        overflow: "auto",
        "& .MuiList-root": {
            display: "block",
            //  flexFlow: "row",
            flexWrap: "nowrap",
            gap: "5px",
            height: "400px", // set the height limit to your liking
            overflow: "auto",
            width: "400px",

        },
        "& .MuiListItem-root": {
            width: 220,
            height: 12,
            //   color: "#772c97"
        },
        "& .MuiListItemText-root": {
            //    width: 180,
            //    height: 20,
            display: "flex",
            textAlign: "left",
            paddingLeft: "5px",
            alignItems: "center"
        },
        "& .MuiDialog-root": {
            height: 500,
            fullwidth: true,
            maxWidth: 'lg'
        },
        "& .MuiDialogTitle - root": {
            textAlign: 'center',
            fontWeight: 500,
            fontSize: 'h4.fontSize',
            backgroundColor: "#1976d2",
            color: "#ffffff"
        },
        "& .MuiDialogContent-root": {
            height: 400
        },
        "& .MuiPaper-root": {
            height: 600
        }

    }

});

export default function Time_Import() {
    const [refresh, setRefresh] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [AllDoneAlert, setAllDoneAlert] = React.useState(false);
    const [successful, setSuccessful] = React.useState([])
    const [returnmessage, setReturnMessage] = React.useState([])
    var importRows = [];
     var newRows = [];
    var rowCount;

    const classes = pageStyles();
    const processRows = (rows) => {
           console.log(`processRows`, rows)
        let processFields = Object.keys(rows[0]);
        //   console.log(`Fields`, processFields)
        for (var i = 0; i < rows.length; i++) {
                  console.log(`loop`, rows[i])
            importRows.push(rows[i])
        }
        newRows = [];
        console.log(`importRows--`, importRows)
    }

    async function pushRows(rows) {
        console.log(`push called`, rows)
        const batchSize = 20; // Number of rows in each batch
        const totalRows = rows.length;
        const numBatches = Math.ceil(totalRows / batchSize);

        for (let i = 0; i < numBatches; i++) {
            const startIndex = i * batchSize;
            const endIndex = Math.min(startIndex + batchSize, totalRows);
            const batchRows = rows.slice(startIndex, endIndex);
            console.log(`batchRows`,batchRows)
            await fetch(`/api/importTime`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    timeEntry: batchRows,
                }),
            })
                .then((res) => res.json())
                .then((json) => {
                    setReturnMessage(json.message);
                });
        }

        // Notify that all rows have been processed
        setAllDoneAlert(true);
    };

    const handleClickOpen = () => {

        setRefresh(true)
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
        setAllDoneAlert(false);

    };
    const handleAlertClose = () => {
        setAllDoneAlert(false);
        handleClose()
    };

    React.useEffect(() => {

        if (refresh) {

            setRefresh(false);
        }
    });
    return (
        <Box>
            <Box sx={{
                width: 400,
                height: 600,
                boxSizing: 'border-box',
                lineHeight: 1.4
            }} >
                <MuiThemeProvider theme={muiThemeDesign}>
                    <Button variant="contained" onClick={handleClickOpen}>
                        Import Time Entry
                    </Button>
                    <Dialog open={open}
                        onClose={handleClose}
                        maxWidth="lg"
                    //      fullScreen
                    >
                        <DialogContent className={classes.overflow}>
                            <Box>

                                <h1>Time Entry Import</h1>

                                <Importer
                                    dataHandler={async (rows) => {
                                        // required, receives a list of parsed objects based on defined fields and user column mapping;
                                        // may be called several times if file is large
                                        // (if this callback returns a promise, the widget will wait for it before parsing more data)
                                        //     console.log("received batch of rows", rows);
                                        rowCount = rows.length;
                                            console.log(`rowCount`, rowCount)                                  
                                        //   newRows.push(rows)
                                      // TEST BYPASS  processRows(rows)
                                      pushRows(rows)
                                    //    setAllDoneAlert(true)


                                        // mock timeout to simulate processing
                                     //   await new Promise((resolve) => setTimeout(resolve, 500));
                                    }}
                                    chunkSize={10000} // optional, internal parsing chunk size in bytes
                                    defaultNoHeader={false} // optional, keeps "data has headers" checkbox off by default
                                    restartable={false} // optional, lets user choose to upload another file when import is complete
                                    onStart={({ file, fields }) => {
                                        // optional, invoked when user has mapped columns and started import
                                        //    console.log("starting import of file", file, "with fields", fields);
                                    }}
                                    onComplete={({ file, fields }) => {
                                        // optional, invoked right after import is done (but user did not dismiss/reset the widget yet)
                                          console.log("finished import of file", file, "with fields", fields);
                                          console.log(`On Complete importRows`, importRows)
                                    //    pushRows(importRows)
                                        setAllDoneAlert(true)
                                    }}
                                    onClose={() => {
                                        // optional, invoked when import is done and user clicked "Finish"
                                        // (if this is not specified, the widget lets the user upload another file)
                                        console.log("importer dismissed");
                                    }}
                                >
                                    <ImporterField name="Email" label="Email" />
                                    <ImporterField name="DayOf" label="DayOf" />
                                    <ImporterField name="WeekOf" label="WeekOf" />
                                    <ImporterField name="Hours" label="Hours" />
                                    <ImporterField name="N/OT" label="N/OT" />
                                    <ImporterField name="Position" label="Position" />
                                    <ImporterField name="ProjectGroup" label="ProjectGroup" />
                                    <ImporterField name="Project" label="Project" />
                                    <ImporterField name="Invoice" label="Invoice" />
                                    <ImporterField name="Lab" label="Lab" />
                                    <ImporterField name="PO" label="PO" />
                                    <ImporterField name="TaskName" label="TaskName" />
                                    <ImporterField name="TaskType" label="TaskType" optional />                                   
                                    <ImporterField name="TaskProp1" label="TaskProp1" optional />
                                    <ImporterField name="TaskProp2" label="TaskProp2" optional />
                                    <ImporterField name="TaskProp3" label="TaskProp3" optional />
                                    <ImporterField name="TaskProp4" label="TaskProp4" optional />
                                    <ImporterField name="TaskProp5" label="TaskProp5" optional />
                                    <ImporterField name="TaskProp6" label="TaskProp6" optional />

                                </Importer>

                            </Box>

                        </DialogContent>
                    </Dialog>

                </MuiThemeProvider>
            </Box>
            <Box
                className={classes.root}
                sx={{
                    lineHeight: 0.9
                }}>
                <Dialog
                    open={AllDoneAlert}
                    onClose={handleAlertClose}
                    fullwidth="true"
                    maxWidth="lg"
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    className={classes.root}
                >
                    <DialogTitle className={classes.root} id="alert-dialog-title" sx={{ textAlign: "center", color: "#ffffff", backgroundColor: "#1976d2" }}>
                        Your Import is Complete
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            <Grid container>
                                <Grid item xs={6} sx={{ border: '1px solid gray' }}>

                                    <Typography textAlign="center" variant="h6" style={{ color: "black" }}>
                                        Time Processed For:
                                    </Typography>
                                    {returnmessage}
                                   {/* <List>
                                        {successful.map(email => {
                                            return (
                                                <ListItem>
                                                    {email}
                                                </ListItem>
                                            )
                                        })
                                        }
                                    </List>*/}
                                </Grid>
                                {/*<Grid item xs={6} sx={{ border: '1px solid gray' }}>
                                    <Typography textAlign="center" variant="h6" style={{ color: "black" }}>
                                        Already Existed
                                    </Typography>
                                    <List>
                                        {duplicates.map(email => {
                                            return (
                                                <ListItem>
                                                    {email}
                                                </ListItem>
                                            )
                                        })
                                        }
                                    </List>
                                </Grid>*/}
                            </Grid>
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>

                        <Button onClick={() => {
                            handleAlertClose()

                        }} autoFocus>
                            OK
                        </Button>
                    </DialogActions>
                </Dialog>
            </Box ></Box >
    );
}








